module.exports = __webpack_public_path__ + "static/media/favicon.f452ae4a.svg";